import { Empty } from 'antd'
import LoaderSpin from 'components/elements/Loader/LoaderSpin'
import React, { FC, Fragment } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { TCommonDataCompo } from 'types'
import { TChatHistoryList } from 'features/chat/types'
import ChatHistoryItem from './ChatHistoryItem'

const ChatHistoryList: FC<TCommonDataCompo<TChatHistoryList[]>> = ({
 data,
 fetchMore,
 hasMore,
 isLoading,
 total,
}) => {
 if (isLoading) {
  return <LoaderSpin mtsMode />
 }

 if (!data || data?.length < 1) {
  return <Empty />
 }

 return (
  <InfiniteScroll
   height="100%"
   className="chat-hi-list"
   loader={
    <p className="text-center py-5 m-0">
     <i className="fa fa-spin fa-spinner" />
    </p>
   }
   next={() => fetchMore?.()}
   dataLength={total || 0}
   hasMore={hasMore || false}
  >
   {data.map((v, i) => (
    <Fragment key={i}>
     <ChatHistoryItem data={v} />
    </Fragment>
   ))}
  </InfiniteScroll>
 )
}

export default ChatHistoryList
